import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import { useResource } from '@atlassian/react-resource-router';

type RovoSubproductAttribution = 'jira' | 'jsm' | 'jpd';

const getAttributionProductFromProjectType = (
	projectType: string | undefined,
): RovoSubproductAttribution => {
	if (projectType === 'service_desk' || projectType === 'customer_service') {
		return 'jsm';
	}
	if (projectType === 'product_discovery') {
		return 'jpd';
	}
	return 'jira';
};

export const useRovoSubproductAttribution = (): RovoSubproductAttribution => {
	const { data: projectContext } = useResource(projectContextResource);
	const projectType = projectContext?.projectType;

	return getAttributionProductFromProjectType(projectType);
};
